<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import SectionContainer from '../components/GenericView/SectionContainer.svelte';
	import ElseActionPreview from '../components/GenericView/ElseActionPreview.svelte';

	export let elses = [];

	const dispatch = createEventDispatcher();
</script>

{#each elses as element, index}
	<SectionContainer class={elses.length - 1 > index ? 'mb-s' : ''}>
		<ElseActionPreview
			{element}
			on:edit-else={() => {
				dispatch('edit-else', index);
			}}
		/>
	</SectionContainer>
{/each}
